import { globalVariables } from "helper/globalVariables";
import { useMediaQuery } from "react-responsive";
import Dropdown from "shared/Components/dropdown";
// import { useMutation } from "@apollo/client";
// import { UPDATE_DOG_STATUS } from "redux/features/editSite/EditSiteApi";

//  // const [updateDogStatus] = useMutation(UPDATE_DOG_STATUS);

//   // const { data: mutationData } = await updateDogStatus({
//   //   variables: {
//   //     id,
//   //     data,
//   //   },
//   // });

export const InfoCard = (props) => {
  const {
    title,
    data,
    showLeft = false,
    isAdmin = false,
    host = false,
    width = "",
    height,
    type = "",
    onSelectSitValue,
  } = props || {};

  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  const isTablet = useMediaQuery({
    query: "(max-width: 1024px) and (min-width: 480px)",
  });

  return (
    <div className={`${width} my-5 md:my-0`}>
      <div
        className={`${height} shadow-100 py-0 border rounded-lg overflow-hidden ${
          isTablet ? "w-[100%] min-h-[260px]" : ""
        }`}
      >
        {!!title && (
          <div className="bg-lightBlue/60 py-4  px-2 flex items-center h-[17%]">
            <span className="px-4 text-xl font-semibold text-gray-900">{title}</span>
            {/* {isAdmin && <TextButton label={globalVariables.edit} />} */}
          </div>
        )}
        <div className="h-[83%] overflow-y-auto py-4 px-4 w-full">
          {data?.length ? (
            data.map((data, index) => (
              <div
                key={data.key}
                className={`flex-row flex justify-between items-center ${
                  isMobile ? "border-b border-gray-200 py-4" : "mb-4 last:mb-0"
                }`}
              >
                <span className={`${type == "SIT" && index === 0 ? 'font-bold' : 'font-medium' } text-base text-gray-700`}>
                  {data.key}
                </span>
                {isAdmin && type === "SIT" && index !== 0 ? (
                  <Dropdown
                    defaultOption={data.value || "Select"}
                    width="w-[100px]"
                    dropdownOptions={["Pass", "Miss"]}
                    onChange={(value) =>
                      onSelectSitValue({ key: data.key, value: value })
                    }
                  />
                ) : (
                  <div
                    className={` w-16 items-center flex justify-center ${index !== 0 && showLeft ? "" : ""}`}
                  >
                    <span
                      className={`text-center self-center flex text-base  text-gray-700 ${
                        type === "SIT" && index === 0 ? "font-bold" : "font-medium"
                      }`}
                    >
                      { isAdmin && type === "SIT"
                        ? data.value
                        : data.value ||  "Pending"}
                    </span>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="flex flex-col justify-center items-center min-h-[290px]">
              <span className="text-base font-medium text-gray-700">
                {globalVariables.noRecord}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
